import React from 'react';
import {Link} from "react-router-dom";
import {ConfigApi} from "../../../../../../../services/Api/types";
import {useTranslation} from "react-i18next";
import MultistoreMapPageNavbarLocation from "./MultistoreMapPageNavbarLocation";
import ResponsiveComponent from "../../../../../../../components/Common/ResponsiveComponent";

interface Props {
    config: ConfigApi;
    setShowAddressModal: React.Dispatch<React.SetStateAction<boolean>>;
}

const MultistoreMapPageNavbar = ({config, setShowAddressModal}: Props) => {
    const {t} = useTranslation();
    const configLayout = config.layout;

    const renderLogo = () => {
        const logo = configLayout.image_link?.default;

        if (logo) {
            return (
                <img alt={t("common.word.location_logo")} src={logo}/>
            )
        }

        return config.name;
    }

    return (
        <nav className="navbar navbar-expand-lg navbar-light sticky-top multistore-map-page-navbar"
             id="main-navbar">
            <div className="navbar-brand-container" id="navbar-brand-container">
                <ResponsiveComponent small={<></>} large={
                    <Link to="/" className="navbar-brand">
                        {renderLogo()}
                    </Link>
                } breakpoint={769}/>
                <MultistoreMapPageNavbarLocation setShowAddressModal={setShowAddressModal}/>
            </div>
        </nav>
    )
}

export default MultistoreMapPageNavbar;